import { render, staticRenderFns } from "./FAQText.vue?vue&type=template&id=2ac3ed0b&scoped=true&"
var script = {}
import style0 from "./FAQText.vue?vue&type=style&index=0&id=2ac3ed0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac3ed0b",
  null
  
)

export default component.exports